import * as Comlink from "comlink";
import type { BackendWorker } from "../workers/backend.worker"; // Type-only import

// Singleton instance
let backend: Comlink.Remote<BackendWorker> | null = null;

export async function getBackend() {
    if (backend) return backend;

    const worker = new Worker("/workers/backend.worker.js", {
        type: "module",
    });

    const Backend = Comlink.wrap<BackendWorker>(worker);
    // Create an instance (since we exposed a class instance, we might need to adjust based on Comlink usage, 
    // but looking at valid usage: usually we expose an object or class. 
    // In `backend.worker.ts` we did `Comlink.expose(new BackendWorker())`, so it wraps the object directly.

    backend = Backend as any;

    // Initialize the worker DB
    await backend!.init();

    return backend!;
}
